document.addEventListener('bundler:bundle_widget_created', function() {
  document.querySelectorAll('.bndlr-mnm-available-products').forEach(function(container) {
    container.querySelectorAll('.bndlr-product').forEach(function(product) {
      product.style.setProperty('display', 'flex', 'important');
      product.style.setProperty('flex-direction', 'column', 'important');

      var pusher = product.querySelector('.bndlr-bottom-pusher');
      if (pusher) pusher.style.setProperty('flex', '1', 'important');
    });

    if (window.innerWidth <= 768) {
      container.style.setProperty('display', 'flex', 'important');
      container.style.setProperty('flex-wrap', 'wrap', 'important');

      container.querySelectorAll('.bndlr-product').forEach(function(product) {
        product.style.setProperty('max-width', 'calc(50% - 12px)', 'important');
        product.style.setProperty('width', 'calc(50% - 12px)', 'important');
        product.style.setProperty('flex', '0 0 calc(50% - 12px)', 'important');
        product.style.setProperty('margin', '4px', 'important');
        product.style.setProperty('box-sizing', 'border-box', 'important');
      });
    }
  });
});